import Api from '../api';

import { errorHandler } from '../common';
const { axios: api } = Api;

export const createSerpMonitoringConfig = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/serp-monitoring/config`, payload);

		return { data: data.data };
	});

export const updateSerpMonitoringConfig = (payload, id) =>
	errorHandler(async () => {
		const data = await api.patch(`/serp-monitoring/config/${id}`, payload);

		return { data: data.data };
	});

export const getSerpMonitoringConfigs = () =>
	errorHandler(async () => {
		const data = await api.get(`/serp-monitoring/config`);

		return { data: data.data };
	});

export const generateSerpMonitoringReport = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/serp-monitoring/generate`, payload);

		return { data: data.data };
	});

export const findSerpMonitoringByProductAndMarket = (payload) =>
	errorHandler(async () => {
		const data = await api.get(`/serp-monitoring/by-product-and-market`, {
			params: payload,
		});

		return { data: data.data };
	});

export const updateSerpMonitoringResultCategory = (payload) =>
	errorHandler(async () => {
		const data = await api.patch(`/serp-monitoring/result/category`, payload);

		return { data: data.data };
	});

export const buildSerpMonitoringXlsx = () =>
	errorHandler(async () => {
		const data = await api.post(`/serp-monitoring/build-xlsx`, {}, {
			responseType: 'blob',
		});

		return { data: data.data };
	});
